<template>
  <div class="qrcode-container">
    <canvas ref="qrcodeCanvas"></canvas>
    <div v-if="qrCodeError" class="error">{{ qrCodeError }}</div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import QRCode from "qrcode";
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      text: {
        type: String,
        required: true, // 二维码内容
      },
      size: {
        type: Number,
        default: 200, // 二维码尺寸
      },
      options: {
        type: Object,
        default: () => ({}), // 额外配置
      },
    },
    data() {
      // 这里存放数据
      return {
        qrCodeError: null,
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      text: "generateQRCode", // 当 `text` 发生变化时，重新生成二维码
    },
    // 方法集合
    methods: {
      async generateQRCode() {
        const canvas = this.$refs.qrcodeCanvas;
        if (!this.text) {
          this.qrCodeError = "二维码内容不能为空";
          return;
        }
        // 解析 size，将带 px 的字符串转为数值
        let size = this.size;
        if (typeof size === "string") {
          size = parseInt(size.replace("px", ""), 10); // 去掉 px 并转为数值
        }

        try {
          // 使用 qrcode 库生成二维码
          await QRCode.toCanvas(canvas, this.text, {
            width: size,
            margin: 1,
            ...this.options,
          });
          this.qrCodeError = null;
        } catch (err) {
          this.qrCodeError = `生成二维码失败: ${err.message}`;
          this.$errorLog('qrcode_generator/generateQRCode', err)
        }
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.generateQRCode();
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .qrcode-container {
    display: inline-block;
    text-align: center;
    max-height: 100%;
    max-width: 100%;
  }
  .error {
    color: red;
    font-size: 14px;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/qrcode_generator.vue